import * as React from 'react';
import styles from './sidebar.module.css';
import { convertStringtoDollarString } from '../../../helpers/formathelper';
import { useGoal } from '../../../contexts/goal/goal.context';
import { SidebarList } from './sidebar-list.component';

export type TStateProps = {
	subModule?: string | undefined | '';
	investorState?: any;
};

export const SideBarComponent: React.FC<TStateProps> = (props: TStateProps) => {
	const { goals } = useGoal();

	const activeState = (subM: any) => {
		return props.subModule === subM ? styles.active : styles.noactive;
	};
	
	return (
		<div className={styles.sideMenu}>
			<nav className={styles.sideMenuNavBar} role="navigation">
				<ul className={styles.rowFlex}>
					<SidebarList
						text={'1. Retirement Age'}
						propsValue={((goals.TargetYear && goals.TargetYear !== 0) && (goals.BirthYear && goals.BirthYear !== 0)) ? (goals.TargetYear-goals.BirthYear) : ''}
						activeClassName={activeState('retirement_age')}
					/>
					<SidebarList
						text={'2. Monthly Income'}
						propsValue={`${
							goals.MonthlyIncome && goals.MonthlyIncome !== 0 ? convertStringtoDollarString(goals.MonthlyIncome) : ''
						}`}
						activeClassName={activeState('monthly_income')}
					/>
					<SidebarList
						text={'3. Retirement Income'}
						propsValue={`${
							goals && goals.NetRetirementMonthlyIncome && goals.NetRetirementMonthlyIncome !== 0
								? `${convertStringtoDollarString(goals.NetRetirementMonthlyIncome)}/month`
								: ''
						}`}
						// propsValue={`${
						// 	goals && (goals.MonthlyIncome && goals.MonthlyIncomeToRetirePercent) 
						// 		? `${convertStringtoDollarString(goals.MonthlyIncome*goals.MonthlyIncomeToRetirePercent/100)}/month`
						// 		: ''
						// }`}
						activeClassName={activeState('retirement_income')}
					/>
					<SidebarList
						text={'4. Monthly Contributions'}
						propsValue={`${
							goals && goals.AnnualSavings !== 0
								? convertStringtoDollarString(goals.AnnualSavings &&  (goals.AnnualSavings / 12))
								: ''
						}`}
						activeClassName={activeState('annual_contribution')}
					/>
				</ul>
			</nav>
		</div>
	);
};
